import PropTypes from 'prop-types'

import { userDetailsPropType } from '../../users/prop-types'

import labelLegendPropType from './label-legend-prop-type'
import menuPropType from './menu-prop-type'

const menuCurationTaskPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  taskStatus: PropTypes.string,
  blockedReason: PropTypes.string,
  curationDetailLevel: PropTypes.string,
  awaitingStatus: PropTypes.string,
  problemReason: PropTypes.string,
  menu: menuPropType,
  assignedTierOneCurator: userDetailsPropType,
  assignedCurator: userDetailsPropType,
  assignedQa: userDetailsPropType,
  assignedUnknownWordsCurator: userDetailsPropType,
  assignedUnknownWordsQa: userDetailsPropType,
  assignedQc: userDetailsPropType,
  assignedScrapingReviewerUser: userDetailsPropType,
  isDeleted: PropTypes.bool,
  dietLabelLegends: PropTypes.arrayOf(labelLegendPropType),
  allergenLabelLegends: PropTypes.arrayOf(labelLegendPropType),
  isReopenedManually: PropTypes.bool,
  reopenedBy: userDetailsPropType,
  createdBy: userDetailsPropType,
  updatedBy: userDetailsPropType,
  curatedBy: userDetailsPropType,
  unknownWordsCuratedBy: userDetailsPropType,
  unknownWordsQadBy: userDetailsPropType,
  qadBy: userDetailsPropType,
  qcdBy: userDetailsPropType,
  updatedAt: PropTypes.string,
  createdAt: PropTypes.string,
  reopenedAt: PropTypes.string,
  unknownWordsCuratedAt: PropTypes.string,
  scrapingClarificationComment: PropTypes.string,
  isScrapingReviewDone: PropTypes.bool,
  unknownWordsQadAt: PropTypes.string,
  tierOneDoneAt: PropTypes.string,
  tierOneDoneBy: userDetailsPropType,
  lastManualUpdateBy: userDetailsPropType,
  curatedAt: PropTypes.string,
  qadAt: PropTypes.string,
  qcdAt: PropTypes.string,
  latestTierOneDoneDishCount: PropTypes.number,
  latestCuratedDishCount: PropTypes.number,
  latestQadDishCount: PropTypes.number,
  latestQcdDishCount: PropTypes.number,
  latestCuratedUnknownWordCount: PropTypes.number,
  latestQadUnknownWordCount: PropTypes.number,
  isAvailableForTierOne: PropTypes.bool,
  isAvailableForUnknownWordsCuration: PropTypes.bool,
  isAvailableForUnknownWordsQa: PropTypes.bool,
  isAvailableForCuration: PropTypes.bool,
  isAvailableForQa: PropTypes.bool,
  isAvailableForQc: PropTypes.bool,
  tierOneCuratorAssignedAt: PropTypes.string,
  unknownWordsCuratorAssignedAt: PropTypes.string,
  unknownWordsQaAssignedAt: PropTypes.string,
  curatorAssignedAt: PropTypes.string,
  lastManualUpdateAt: PropTypes.string,
  qaAssignedAt: PropTypes.string,
  qcAssignedAt: PropTypes.string,
})

menuCurationTaskPropType.defaultProps = {
  taskStatus: undefined,
  blockedReason: undefined,
  curationDetailLevel: undefined,
  awaitingStatus: undefined,
  problemReason: undefined,
  menu: undefined,
  assignedCurator: undefined,
  assignedQa: undefined,
  assignedUnknownWordsCurator: undefined,
  assignedUnknownWordsQa: undefined,
  assignedQc: undefined,
  dietLabelLegends: [],
  allergenLabelLegends: [],
  isDeleted: undefined,
  isReopenedManually: undefined,
  reopenedBy: undefined,
  createdBy: undefined,
  updatedBy: undefined,
  curatedBy: undefined,
  qadBy: undefined,
  qcdBy: undefined,
  updatedAt: undefined,
  createdAt: undefined,
  reopenedAt: undefined,
  unknownWordsCuratedAt: undefined,
  unknownWordsQadAt: undefined,
  tierOneDoneAt: undefined,
  tierOneDoneBy: undefined,
  curatedAt: undefined,
  qadAt: undefined,
  qcdAt: undefined,
  latestTierOneDoneDishCount: 0,
  latestCuratedDishCount: 0,
  latestQadDishCount: 0,
  latestQcdDishCount: 0,
  latestCuratedUnknownWordCount: 0,
  latestQadUnknownWordCount: 0,
  isAvailableForTierOne: undefined,
  isAvailableForUnknownWordsCuration: undefined,
  isAvailableForUnknownWordsQa: undefined,
  isAvailableForCuration: undefined,
  isAvailableForQa: undefined,
  isAvailableForQc: undefined,
}

export default menuCurationTaskPropType
